import { useEffect, useState } from 'react';

const KEY = 'operio-theme';

export const getTheme = () => localStorage.getItem(KEY) || 'light';

export const applyTheme = (theme) => {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  localStorage.setItem(KEY, theme);
  window.dispatchEvent(new CustomEvent('operio-theme', { detail: theme }));
};

export const useTheme = () => {
  const [theme, setTheme] = useState(getTheme());
  useEffect(() => {
    const h = (e) => setTheme(e.detail);
    window.addEventListener('operio-theme', h);
    return () => window.removeEventListener('operio-theme', h);
  }, []);
  return [theme, () => applyTheme(theme === 'dark' ? 'light' : 'dark')];
};
